import React from 'react';

import { PenLine } from 'lucide-react';

import type { SimpleIconInterface } from './icon-utils';

export function SignatureFieldIcon(props: SimpleIconInterface): JSX.Element {
  const { className, dataCy, height, stroke, strokeWidth, style, width } = props;

  return (
    <PenLine
      className={className}
      data-cy={dataCy}
      height={height ?? 18}
      stroke={stroke ?? 'currentColor'}
      strokeWidth={strokeWidth}
      style={style}
      width={width ?? 18}
    />
  );
}
